import React from 'react';
import './Accompagnements.scss';

/**
 * Page décrivant les différentes formes d'accompagnement proposées.
 */
const Accompagnements = () => {
  const services = [
    {
      title: "Remédiation cognitive",
      duration: "50 minutes",
      description: "La remédiation cognitive vise à diminuer l’impact des difficultés cognitives, objectivées lors du bilan neuropsychologique, dans le quotidien du patient et de favoriser son autonomie.",
      details: [
        "Au travers d’exercices, le renforcement de certaines compétences cognitives peut être travaillé.",
        "Elle permet également de mettre en place des stratégies compensatoires adaptées permettant de réduire les gênes rencontrées au quotidien."
      ]
    },
    {
      title: "Psychoéducation",
      duration: "50 minutes",
      description: "Cette méthode thérapeutique permet de former le patient et son entourage.",
      details: [
        "L’objectif est une meilleure compréhension du fonctionnement d'un trouble, ses répercussions et les moyens de mieux le gérer au quotidien.",
        "Elle favorise une meilleure connaissance de soi et le développement de stratégies adaptées."
      ]
    },
    {
      title: "Accompagnement des familles et des proches",
      duration: "50 minutes",
      description: "Les proches jouent un rôle essentiel dans l'accompagnement des personnes présentant des difficultés cognitives.",
      details: [
        "Des temps d'échange peuvent leur être proposés afin de répondre à leurs questions, les informer et les soutenir."
      ]
    }
  ];

  return (
    <div className="accompagnements-page container">
      <header className="page-header">
        <h1>Les accompagnements</h1>
        <p className="subtitle">
          Une prise en charge adaptée peut être proposée à la suite d’un bilan neuropsychologique au patient et à sa famille. 
          Les séances proposées varient selon la problématique de chacun et de ses besoins.
        </p>
      </header>

      <div className="services-grid">
        {services.map((service, index) => (
          <div key={index} className="service-card">
            <div className="service-header">
              <h2>{service.title}</h2>
              <span className="duration-tag">{service.duration}</span>
            </div>
            <p className="service-intro">{service.description}</p>
            <ul className="service-details">
              {service.details.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Accompagnements;